if (!customElements.get('video-component')) {
  class VideoComponent extends HTMLElement {
    constructor() {
      super();

      this.video = this.querySelector('video');
    }

    connectedCallback() {
      this.addEventListener('click', () => {
        this.video.paused ? this.video.play() : this.video.pause();

        this.classList.toggle('is-playing', !this.video.paused);
      });

      this.video.addEventListener('ended', () => {
        this.classList.remove('is-playing');
      });
    }
  }

  customElements.define('video-component', VideoComponent);
}
